enum CumulShareType {
  USER = "users",
  TEAM = "teams",
  ORG = "public",
}

export default CumulShareType;
